export function handleDecisionResponse(lazyPromise, explain) {
	console.log('handleDecisionResponse lazyPromise', lazyPromise);
	console.log('handleDecisionResponse explain', explain);
	return handleError(lazyPromise, undefined, explain);
}
export function handleExplain(explain, applySolution) {
	return handleError(explain, r => processExplainAnswer(r, applySolution));
}

export function handleError(lazyPromise, onResult, onError, errorMessageAddition) {
	return lazyPromise()
		.then((r) => {
			if (onResult) {
				onResult(r);
			}
		})
		.catch(error => {
			const message = 'An error occurred while executing the request:\n' + JSON.stringify(error, null, 4);
			console.error(message);
			const execute = 'type' in error && onError && onError(error);
			execute();
		});
}
export async function processExplainAnswer(answer, applySolution) {
	console.log('processExplainAnswer', answer);
	await handleError(() => applySolution(answer[0].solution));
}
